import { useState } from 'react'
import styles from './EditArrowMenu.module.scss'
import { TrashIcon } from '@phosphor-icons/react'
import { deleteArrow, updateArrow } from '../../../../store/actions'
import { useDispatch } from 'react-redux'
import { ReorderPicker } from '../../components/ReorderPicker/ReorderPicker'
import { ScoopSelector, ScoopColorPicker, ScoopButton } from '../../../ui'
import { useModal, MODALS } from '../../../modals'

export const EditArrowMenu = ({ id, arrowProps, handleDelete, setArrowProps }) => {
    const dispatch = useDispatch()
    const deleteModal = useModal(MODALS.COMMON.DELETE)
    const [arrowHead, setArrowHead] = useState(
        arrowProps.showTail && arrowProps.showHead
            ? 'both'
            : !arrowProps.showTail && arrowProps.showHead
              ? 'end'
              : arrowProps.showTail && !arrowProps.showHead
                ? 'start'
                : ''
    )

    const handleUpdateArrow = (key, value) => {
        setArrowProps(value)
        dispatch(updateArrow(id, { key, value }))
    }

    const handleDeleteArrow = () => {
        handleDelete()
        dispatch(deleteArrow(id))
    }

    const handleArrowHeadChange = (value) => {
        setArrowHead(value)
        switch (value) {
            case 'start':
                handleUpdateArrow('arrowProps', {
                    ...arrowProps,
                    showTail: true,
                    showHead: false,
                })
                break
            case 'end':
                handleUpdateArrow('arrowProps', {
                    ...arrowProps,
                    showTail: false,
                    showHead: true,
                })
                break
            case 'both':
                handleUpdateArrow('arrowProps', {
                    ...arrowProps,
                    showTail: true,
                    showHead: true,
                })
                break
        }
    }

    const pathOptions = [
        { label: 'Smooth', value: 'smooth' },
        { label: 'Grid', value: 'grid' },
        { label: 'Straight', value: 'straight' },
    ]

    const arrowHeadOptions = [
        { label: 'Start', value: 'start' },
        { label: 'End', value: 'end' },
        { label: 'Both', value: 'both' },
    ]

    const anchorOptions = [
        { label: 'Auto', value: 'auto' },
        { label: 'Left', value: 'left' },
        { label: 'Right', value: 'right' },
        { label: 'Top', value: 'top' },
        { label: 'Bottom', value: 'bottom' },
    ]

    return (
        <div id="arrow-menu" className={styles.menuContainer}>
            <ScoopSelector
                value={arrowProps.path}
                onChange={(e) =>
                    handleUpdateArrow('arrowProps', {
                        ...arrowProps,
                        path: e.target.value,
                    })
                }
                options={pathOptions}
                label="Path"
                size="xs"
                removeMargin
            />
            <ScoopSelector
                value={arrowHead}
                onChange={(e) => handleArrowHeadChange(e.target.value)}
                options={arrowHeadOptions}
                label="Arrow head"
                size="xs"
                removeMargin
            />
            <ScoopSelector
                value={arrowProps.startAnchor}
                onChange={(e) =>
                    handleUpdateArrow('arrowProps', {
                        ...arrowProps,
                        startAnchor: e.target.value,
                    })
                }
                options={anchorOptions}
                label="Start anchor"
                size="xs"
                removeMargin
            />
            <ScoopSelector
                value={arrowProps.endAnchor}
                onChange={(e) =>
                    handleUpdateArrow('arrowProps', {
                        ...arrowProps,
                        endAnchor: e.target.value,
                    })
                }
                options={anchorOptions}
                label="End anchor"
                size="xs"
                removeMargin
            />
            <ScoopColorPicker
                value={arrowProps.color}
                onChange={(color) => handleUpdateArrow('arrowProps', { ...arrowProps, color })}
                width={20}
                height={20}
                origin="bottom"
            />
            <ScoopButton
                variant="text"
                size="sm"
                onClick={() =>
                    deleteModal.show({
                        title: 'Arrow',
                        type: 'arrow',
                        onDelete: handleDeleteArrow,
                    })
                }
                className={styles.deleteButton}
            >
                <TrashIcon size={20} weight="regular" />
            </ScoopButton>
            <ReorderPicker origin={'bottom'} objectId={id} tooltip />
        </div>
    )
}
